document.addEventListener("DOMContentLoaded", () => {
  // Va al checkout pasando por WSH Wholesale Pricing. La app escucha clics en
  // el body sobre button[name='checkout'] y, si hay descuento, crea el draft
  // order y redirige a su checkout. Los botones propios frenan ese clic, así
  // que lanzamos uno interno: si la app lo toma (preventDefault) esperamos su
  // redirección; si no, vamos a /checkout directo.
  function goToCheckout() {
    const proxy = document.createElement("button");
    proxy.type = "button";
    proxy.name = "checkout";
    proxy.className = "wcp_checkout_btn";
    proxy.style.display = "none";
    document.body.appendChild(proxy);

    const notHandled = proxy.dispatchEvent(
      new MouseEvent("click", { bubbles: true, cancelable: true })
    );
    proxy.remove();

    if (notHandled) {
      window.location.href = "/checkout";
    } else {
      // Red de seguridad por si la app no llega a redirigir.
      setTimeout(() => {
        window.location.href = "/checkout";
      }, 15000);
    }
  }

  // El drawer se actualiza por AJAX y WSH conserva un cálculo viejo del carrito,
  // por lo que su descuento no se aplica. /cart recarga la página y WSH recalcula.
  // Con sesión iniciada pasamos por /cart y disparamos allí el pago.
  const WSH_AUTO_CHECKOUT_KEY = "wsh_auto_checkout";

  function goToCheckoutFromDrawer() {
    const loggedIn =
      window.is_wcp_wholesale_customer === true ||
      (window.wcp_customer && window.wcp_customer.id);

    if (!loggedIn) {
      goToCheckout();
      return;
    }

    try {
      sessionStorage.setItem(WSH_AUTO_CHECKOUT_KEY, "1");
    } catch (err) {
      goToCheckout();
      return;
    }
    window.location.href = "/cart";
  }

  function showTippyError(el, msg, duration = 1100) {
    if (el._excesoTippy) {
      el._excesoTippy.destroy();
    }

    // Crea el tooltip
    const tip = tippy(el, {
      content: msg,
      placement: "top",
      theme: "error", // Define un tema CSS si quieres: .tippy-box[data-theme~="error"] { ... }
      trigger: "manual",
      hideOnClick: false,
      animation: "scale",
    });

    el._excesoTippy = tip; // Guarda la instancia por si necesitas destruirla luego

    tip.show();

    // Auto‑hide y destruir para no dejar basura
    setTimeout(() => {
      tip.hide();
      tip.destroy();
      delete el._excesoTippy;
    }, duration);
  }

  window.initCartDrawerValidation = function () {
    const form = document.querySelector("#CartDrawer-Form");
    const externalBtn = document.querySelector("#CartDrawer-Checkout");

    if (!form || !externalBtn) {
      console.warn("❌ Formulario o botón de checkout no encontrado.");
      return;
    }

    if (externalBtn.dataset.listenerAttached === "true") return;
    externalBtn.dataset.listenerAttached = "true";

    // Botón interno oculto
    let internalSubmitBtn = form.querySelector("button[data-internal-submit]");
    if (!internalSubmitBtn) {
      internalSubmitBtn = document.createElement("button");
      internalSubmitBtn.type = "submit";
      internalSubmitBtn.style.display = "none";
      internalSubmitBtn.setAttribute("data-internal-submit", "true");
      form.appendChild(internalSubmitBtn);
    }

    // Validación
    function validarBolsasDrawer() {
      let giftQty = 0;
      let totalProductQty = 0;

      form.querySelectorAll('input[name="updates[]"]').forEach((input) => {
        if (input.offsetParent === null) return;

        const qty = parseInt(input.value, 10) || 0;
        const isGift = input.getAttribute('data-is-gift-bag') === 'true';

        if (isGift) {
          giftQty += qty;
        } else {
          totalProductQty += qty;
        }
      });

      return giftQty <= totalProductQty;
    }

    // Click externo
    externalBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (validarBolsasDrawer()) {
        const addOffer = window.addCartOfferBeforeCheckout
          ? window.addCartOfferBeforeCheckout()
          : Promise.resolve();

        addOffer.finally(goToCheckoutFromDrawer);
      }
    });
  };

  function observeCartDrawerGlobally() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        const addedNodes = Array.from(mutation.addedNodes);

        for (const node of addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          // Buscar si se insertó el contenedor del cart drawer
          if (
            node.matches("#CartDrawer-CartItems") ||
            node.querySelector?.("#CartDrawer-CartItems")
          ) {
            setTimeout(initCartDrawerValidation, 100); // espera pequeño para asegurar render
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  observeCartDrawerGlobally();

  // En caso de que ya esté montado desde el inicio
  if (document.querySelector("#CartDrawer-CartItems")) {
    initCartDrawerValidation();
  }
  /////////////// INICIO DEL CART
  const cartContainer = document.querySelector("#main-cart-items");

  // Almacenar cantidades previas para detectar cambios
  const cantidadPrevias = new WeakMap();

  function validarBolsasCart() {
    const items = cartContainer.querySelectorAll(".cart-item");
    let totalNormales = 0;
    let totalBolsas = 0;

    items.forEach((item) => {
      const nombreProducto = item
        .querySelector(".cart-item__name")
        ?.textContent?.trim()
        ?.toUpperCase();
      const cantidad = parseInt(
        item.querySelector(".quantity__input")?.value || "0"
      );

      if (nombreProducto.includes("BOLSA DE REGALO")) {
        totalBolsas += cantidad;
      } else {
        totalNormales += cantidad;
      }
    });

    const exceso = totalBolsas > totalNormales;
    return { exceso, totalBolsas, totalNormales };
  }

  function aplicarLogicaBolsa() {
    cartContainer.querySelectorAll(".cart-item").forEach((item) => {
      const input = item.querySelector(".quantity__input");
      if (!input || input.dataset.listener === "true") return;

      input.dataset.listener = "true";

      input.addEventListener("change", (e) => {
        const input = e.target;
        const item = input.closest(".cart-item");
        if (!item) return;

        const nombreProducto = item
          .querySelector(".cart-item__name")
          ?.textContent?.trim()
          ?.toUpperCase();

        // Solo para bolsas de regalo
        if (!nombreProducto.includes("BOLSA DE REGALO")) return;

        // Obtener cantidad previa
        let prev = cantidadPrevias.get(input);
        if (prev === undefined || prev === null || isNaN(prev)) {
          prev = parseInt(input.value) || 0;
        }
        const current = parseInt(input.value) || 0;

        const { exceso, totalBolsas, totalNormales } = validarBolsasCart();

        if (exceso) {
          input.value = prev;
          input.setAttribute("value", prev);
          input.dispatchEvent(new Event("change", { bubbles: true }));
          showTippyError(
            input,
            "Sólo puedes llevar un máximo de " +
              totalNormales +
              " bolsas en total."
          );
        } else {
          cantidadPrevias.set(input, current);
        }
      });

      // Guardar cantidad inicial
      const inicial = parseInt(input.value) || 0;
      cantidadPrevias.set(input, inicial);
    });
  }

  if (cartContainer) {
    // Al cargar
    aplicarLogicaBolsa();

    // Re-observar cambios por AJAX
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "childList" || mutation.type === "subtree") {
          aplicarLogicaBolsa();
        }
      }
    });

    observer.observe(cartContainer, { childList: true, subtree: true });
  }

  /// BTN CHECKOUT

  // Referencia al botón custom
  const customCheckoutBtn = document.querySelector(".gotocheckout_custom");

  if (customCheckoutBtn) {
    customCheckoutBtn.addEventListener("click", (e) => {
      // Evita que el clic real llegue a WSH a la vez que el interno.
      e.preventDefault();
      e.stopPropagation();

      const { exceso, totalBolsas, totalNormales } = validarBolsasCart();

      if (exceso) {
        showTippyError(
          customCheckoutBtn,
          "Sólo puedes llevar un máximo de " +
            totalNormales +
            " bolsas en total."
        );
      } else {
        const addOffer = window.addCartOfferBeforeCheckout
          ? window.addCartOfferBeforeCheckout()
          : Promise.resolve();

        addOffer.finally(goToCheckout);
      }
    });
  }

  // Llegada desde el drawer: espera a que WSH calcule el carrito y sigue al pago.
  let autoCheckout = false;
  try {
    autoCheckout = sessionStorage.getItem(WSH_AUTO_CHECKOUT_KEY) === "1";
    sessionStorage.removeItem(WSH_AUTO_CHECKOUT_KEY);
  } catch (err) {
    /* sin sessionStorage */
  }

  if (autoCheckout && customCheckoutBtn) {
    const startedAt = Date.now();
    const waitForWsh = setInterval(() => {
      const ready = window.wcp_data && window.wcp_data.discounted_hash;
      if (ready || Date.now() - startedAt > 3000) {
        clearInterval(waitForWsh);
        goToCheckout();
      }
    }, 200);
  }
});
